// extracted by mini-css-extract-plugin
export var standaloneTable = "_ee-0";
export var standaloneTableWithBodyFill = "_ee-1";
export var withExtraHeader = "_ee-2";